// import axios from 'axios';

// const api = axios.create({
//   baseURL: 'http://localhost:4000/api', // Node backend base URL
// });

// export default api;


import axios from "axios";
import { getAuthSession } from "./auth";

const api = axios.create({
  baseURL: "/api",
});

// Attach Authorization header for manager JWT when present
api.interceptors.request.use((config) => {
  const session = getAuthSession();
  if (session?.token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${session.token}`;
  }
  return config;
});

export default api;
